/**
 * created by wang lei
 删除行 页面
 *
 */
import React, {Component} from 'react';
import deleteRows from './deleteRows.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class DeleteRowsTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deleteRows:false
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let deleteRows = this.props.editor.queryCommandState('deleteTable')
        this.setState({deleteRows: deleteRows === 0});
    }

    /**
     * 监听编辑器点
     */
    listenContentClick(){
        let deleteRows = this.props.editor.queryCommandState('deleteTable')
        this.setState({deleteRows: deleteRows === 0});
    }
    render() {
        return (
            <span style={{cursor:"pointer",opacity:this.state.deleteRows ? "1":"0.3"}} onClick={()=>{
                this.props.editor.execCommand("deleterow")
            }}>
                <img className={"editor-delete-rows-tool-btn"} src={deleteRows}/>
                {this.state.deleteRows ? <style>{`
                .editor-delete-rows-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-delete-rows-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-delete-rows-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style> : <style>{`
                .editor-delete-rows-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-delete-rows-tool-btn:hover{
                    border: 1px solid transparent
                }
                .editor-delete-rows-tool-btn:active{
                    border: 1px solid transparent
                }
            `}</style>}

            </span>
        )
    }

}